// Castintech dashboard — Keyboard shortcuts.
// Faz 9b PR9 + Faz 10 PR1. Faz 13 — strict TS hardening.
// Esc → close all open panels; 1-7 nav; r refresh; ? help.

import { $, asEl } from '../utils.js';
import { navigate, refresh } from '../main.js';
import { closeDetail } from './detail-panel.js';
import { closeInfoDrawer } from './drawer.js';
import { closeNewIssue } from '../views/pano.js';
import { closeTelegramSend } from '../views/telegram.js';
import type { PageId } from '../../types/state';

export function toggleKbd(): void {
  $('kbd-panel')?.classList.toggle('visible');
}

// Faz 10 PR1 — kbd-toggle (?) butonuna click listener bind.
let _kbdBound = false;
export function bindKbdToggle(): void {
  if (_kbdBound) return;
  const btn = document.querySelector<HTMLElement>('.kbd-toggle');
  if (btn) btn.addEventListener('click', toggleKbd);
  _kbdBound = true;
}

document.addEventListener('keydown', (e: KeyboardEvent) => {
  // INPUT/TEXTAREA/SELECT focus iken kisayollari devre disi birak.
  const target = asEl(e.target);
  const tag = target?.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;

  if (e.key === 'Escape') {
    closeDetail();
    closeNewIssue();
    closeInfoDrawer();
    closeTelegramSend();
    $('kbd-panel')?.classList.remove('visible');
  }
  const navMap: Record<string, PageId> = {
    '1': 'pano', '2': 'ekip', '3': 'canli', '4': 'onaylar',
    '5': 'skills', '6': 'telegram', '7': 'saglik',
  };
  const navTarget = navMap[e.key];
  if (navTarget) navigate(navTarget);
  if (e.key === 'r' || e.key === 'R') refresh();
  if (e.key === '?') toggleKbd();
});
